import React from 'react'
import { Avatar, Card, Flexbox } from '@/components'
import dateMask from '@/lib/masks/date'
import documentNumberMask from '@/lib/masks/documentNumber'
import phoneNumber from '@/lib/masks/phoneNumber'
import PropTypes from 'prop-types'
import FormProfile from './Form'

function PartnerDataCard({ licensing, onUpdated }) {
  return (
    <Flexbox.Columns>
      <Flexbox.Column className="col-12 col-lg-6 col-sm-12 my-2">
        <Card.Base>
          <Card.Header>
            <div className="divider text-left" data-content="Dados do perfil" />
          </Card.Header>
          <Card.Body>
            <Flexbox.Columns>
              <Flexbox.Column className="col-auto">
                <Avatar
                  avatarSize="lg"
                  name={licensing?.fullName}
                  photoURL={licensing?.photoURL}
                  alt="Imagem de usuário"
                />
              </Flexbox.Column>
              <Flexbox.Column>
                <div className="text-primary text-bold">
                  {licensing?.fullName}
                </div>
                <div className="text-small">
                  {licensing?.documentNumber
                    ? documentNumberMask(licensing?.documentNumber)
                    : '-'}
                </div>
              </Flexbox.Column>
            </Flexbox.Columns>
            <div className="divider" />
            {licensing?.documentNumber?.length === 11 && (
              <Flexbox.Columns className="mb-1">
                <Flexbox.Column>Data de nascimento</Flexbox.Column>
                <Flexbox.Column className="col-auto text-bold">
                  {licensing?.birthdayDate
                    ? String(
                        dateMask(licensing?.birthdayDate, {
                          dateStyle: 'short',
                        }),
                      )
                    : 'Não informado'}
                </Flexbox.Column>
              </Flexbox.Columns>
            )}
            <Flexbox.Columns className="mb-1">
              <Flexbox.Column>E-mail</Flexbox.Column>
              <Flexbox.Column className="col-auto text-bold">
                {licensing?.email}
              </Flexbox.Column>
            </Flexbox.Columns>
            <Flexbox.Columns className="mb-1">
              <Flexbox.Column>Fone</Flexbox.Column>
              <Flexbox.Column className="col-auto text-bold">
                {licensing?.phoneNumber
                  ? phoneNumber(licensing?.phoneNumber)
                  : 'Não informado'}
              </Flexbox.Column>
            </Flexbox.Columns>
          </Card.Body>
          <Card.Footer className="text-end">
            <FormProfile onUpdated={onUpdated} />
          </Card.Footer>
        </Card.Base>
      </Flexbox.Column>
    </Flexbox.Columns>
  )
}

PartnerDataCard.propTypes = {
  licensing: PropTypes.objectOf(PropTypes.any),
  onUpdated: PropTypes.func.isRequired,
}

PartnerDataCard.defaultProps = {
  licensing: null,
}

export default PartnerDataCard
